var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCameraPlay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    viewBox: "0 0 73 50",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#414042",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M69.813 49c-.887 0-1.78-.354-2.655-1.053L54.551 37.873C52.527 36.256 51 33.083 51 30.493V19.507c0-2.59 1.527-5.763 3.552-7.38L67.158 2.053C68.033 1.354 68.926 1 69.813 1 71.399 1 73 2.193 73 4.858v40.284c0 1.019-.235 1.874-.697 2.544A2.991 2.991 0 0169.813 49zm-.48-43.995l-12.491 9.982c-1.139.91-2.175 3.063-2.175 4.52v10.986c0 1.457 1.036 3.611 2.175 4.52l12.491 9.982V5.005zM42.462 49H5.538C2.485 49 0 46.567 0 43.577V7.423C0 4.433 2.485 2 5.538 2h36.924C45.515 2 48 4.433 48 7.423v36.154C48 46.567 45.515 49 42.462 49zM5.538 5.615c-1.017 0-1.846.811-1.846 1.808v36.154c0 .997.829 1.808 1.846 1.808h36.924c1.017 0 1.846-.811 1.846-1.808V7.423c0-.997-.829-1.808-1.846-1.808H5.538z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.833 38a1.87 1.87 0 01-.903-.232 1.778 1.778 0 01-.93-1.554V14.786c0-.644.355-1.237.93-1.554a1.876 1.876 0 011.847.022L36.11 23.97c.552.323.89.904.89 1.531 0 .627-.338 1.209-.89 1.531L17.777 37.746c-.29.169-.617.254-.944.254zm1.834-20.06v15.12l12.936-7.56-12.936-7.56z"
  }))));
}

export default SvgCameraPlay;